<template lang="pug">
.dashboard
  .frow
    .box
      .frow.justify-between.items-center
        div
          h1.title-call-out Dashboard
          h3 Welcome, {{ user.name }}
        img.user-image(:src="user.photoUrl")
      .frow.justify-between.items-center.dashboard-header
        .frow.row-end.dashboard-buttons
          VButton(
            text="Edit Profile"
            @click.native="$router.push('/edit-profile')"
          )
          | &nbsp;
          VButton(
            v-if="user.role.type === 'admin'"
            text="Admin"
            @click.native="$router.push('/admin')"
          )
          | &nbsp;
          VButton(
            text="Logout"
            @click.native="$store.commit('logout')"
          )
      .frow.info-section
        //- .col-md-1-1
        //-   strong Tags:
        //-   br
        //-   span.tag.clr-bg-primary(v-for="tag in user.tags") {{ tag }}
      .frow.info-section
        .col-md-1-1.content
          strong Bio:
          br
          blockquote {{ user.bio }}
      .frow.info-section
        p.clr-primary {{ user.email }}
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "dashboard",
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  mounted() {
    this.$store.dispatch("getUser");
  }
};
</script>
<style lang="scss" scoped>
.box {
  width: 900px;
  h3 {
    font-size: 1.75rem;
  }
  h5 {
    margin-top: 15px;
    font-style: italic;
  }
}

.dashboard {
  .dashboard-header {
    border-bottom: 1px solid;
    padding: 10px 0;
    margin-bottom: 25px;
  }
  .info-section {
    margin-bottom: 25px;
  }
}

.user-image {
  width: 100%;
  height: 150px;
  border-radius: 50%;
  max-width: 150px;
  display: block;
  margin: 0 auto;
}
</style>
